export const createTaxSuffixString = (
  displayRecommendation: 'inclusive' | 'exclusive',
  taxCode: 'GST' | 'VAT' | 'PPN' | 'SST',
  inclusiveRecommendationTranslated: string,
  exclusiveRecommendationTranslated: string,
) => {
  const inclusivePrefix =
    displayRecommendation === 'inclusive'
      ? inclusiveRecommendationTranslated
      : exclusiveRecommendationTranslated;

  const taxSuffix = inclusivePrefix + taxCode;

  return taxSuffix;
};
